import moment from "moment-timezone";
import ReactDOM from "react-dom";
import React, { memo, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getCenter } from "geolib"
import { GoogleApiWrapper, Map } from "google-maps-react";
import { Shape } from "../map/geo/DrawingTools";
import { DISPLAY_DATE_FORMAT2 } from '../../constants';
import config from "../../constants/config";
import { secondsToTime, toDisplayTimeString } from '../../helpers/moment-ex';
import { GEO_SHAPE_TYPE, uuid } from '../../helpers/common';
import { setSearchQueryData } from "../../helpers/session";
import fieldMarkerIcon from '../../../assets/images/field_pin.png';
import offloadMarkerIcon from '../../../assets/images/offload_pin.png';

const LoadMap = props => {
	const { loadInfo, location: loadLocation, regionsDetail } = props;
	const [map, setMap] = useState(null);
	const [google, setGoogle] = useState(null);
	const [markers, setmarker] = useState({ field: null, offload: null, curveMarker: null });
	const [mapBounds, setMapBounds] = useState(null);
	const weightShortName = useSelector(state => state.user.settings.weightShortName);
	const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);

	const mapRef = useRef()

	const shape = new Shape(props.google);

	const fieldDetail = regionsDetail && loadInfo && regionsDetail[loadInfo.field_geo_region_uuid] ? regionsDetail[loadInfo.field_geo_region_uuid] : null;
	const offloadDetail = regionsDetail && loadInfo && regionsDetail[loadInfo.offload_geo_region_uuid] ? regionsDetail[loadInfo.offload_geo_region_uuid] : null;

	const getOffLoadInfo = (offloadShapeId) => {
		if (!regionsDetail && !offloadShapeId) return null;
		let newRegionId = null;
		for (const regionid of Object.keys(regionsDetail)) {
			const region = regionsDetail && regionsDetail[regionid] ? regionsDetail[regionid] : null;
			const regionShapes = region && region.shapes && region.shapes.length !== 0 ?
				region.shapes : [];
			for (const shape of regionShapes) {
				if (shape.geo_shape_uuid === offloadShapeId) {
					newRegionId = regionid;
				}
			}
		}
		return newRegionId ? regionsDetail[newRegionId] : null;
	}

	const getRegionData = (regionDetail, shapeId) => {
		const regionShapes = regionDetail && regionDetail.shapes && regionDetail.shapes.length !== 0 ?
			regionDetail.shapes.filter((e) => e.geo_shape_uuid === shapeId) : [];
		const regionShape = regionShapes && regionShapes.length !== 0 ? regionShapes[0] : null;
		const regionLocation = regionShape ? regionShape.location.map((e) => { return { lat: e.lat, lng: e.lng } }) : [];
		const regionShapeType = regionShape ? regionShape.geo_shape_type : null;
		return { regionShape, regionLocation, regionShapeType }
	}

	const checkValidId = (id) => id && id.toString() !== 'implement_unknown' && id.toString() !== 'unknown' ? true : false;

	const goToReplayBox = (data) => {
		const searchId = uuid();
		const egULR = `/home/farm/${farmId}/map/eg?sub=0&searchId=${searchId}`
		const searchQuery = {
			data: {
				...data,
				farm_uuid: farmId,
			},
			search_id: searchId
		};
		setSearchQueryData(searchQuery);
		window.open(egULR);
	}

	const offLoadInfo = regionsDetail && loadInfo && offloadDetail ? offloadDetail : getOffLoadInfo(loadInfo && loadInfo.hasOwnProperty('offload_geo_shape_uuid') ? loadInfo.offload_geo_shape_uuid : null);
	const { regionShape: fieldShape, regionLocation: fieldLocation, regionShapeType: fieldShapeType } = (loadInfo && loadInfo.hasOwnProperty('field_geo_shape_uuid') && fieldDetail) ? getRegionData(fieldDetail, loadInfo.field_geo_shape_uuid) : {};
	const { regionShape: offloadShpe, regionLocation: offloadLocation, regionShapeType: offloadShapeType } = loadInfo && loadInfo.hasOwnProperty('offload_geo_shape_uuid') && offLoadInfo ? getRegionData(offLoadInfo, loadInfo.offload_geo_shape_uuid) : {};

	const staticOptions = {
		fillColor: "#baf5d593",
		fillOpacity: 1,
		strokeColor: "#ffff",
		strokeOpacity: 1,
		strokeWeight: 2,
		clickable: false,
		draggable: false,
		editable: false,
		geodesic: false,
		mapTypeId: 'satellite',
		zIndex: 3,
	};

	const mapStyles = {
		position: 'absolute',
		inset: '0px',
		width: '99%',
		height: '540px',
		display: 'inherit',
		overflow: 'hidden',
		marginLeft: '-13px',
	};

	useEffect(() => {
		const { google } = props;
		if (mapRef && mapRef['current'] && mapRef['current'].hasOwnProperty("map")) {
			setMap(mapRef.current.map);
		}
		setGoogle(google);
	}, []);

	useEffect(() => {
		if (google && loadInfo) {
			const filed = fieldShape ? drawShape(fieldShapeType,
				{
					id: fieldShape.geo_shape_uuid,
					location: fieldLocation,
					properties: fieldShape.properties
				}) : null;
			const offload = offloadShpe ? drawShape(offloadShapeType,
				{
					id: offloadShpe.geo_shape_uuid,
					location: offloadLocation,
					properties: offloadShpe.properties
				}) : null;

			let filedMarker = null, offloadMarker = null;
			if (filed) {
				filed.setMap(map);
				filedMarker = drawShape('marker', {
					id: uuid(),
					location: loadLocation,
					properties: {
						icon: {
							url: fieldMarkerIcon,
							scaledSize: new google.maps.Size(30, 40),
						},
						visible: true
					}
				});
				const fieldInfoLoadDiv = document.createElement("div");
				fieldInfoLoadDiv.setAttribute("class", 'info-load');

				ReactDOM.render(React.Children.only(<table>
					<tbody>
						<tr><td><span>Field</span></td><td>:</td><td><label>{fieldShape.geo_shape_name || "N/A"}</label></td></tr>
						{loadInfo.load_date && <tr><td><span>Load Date</span></td><td>:</td><td><label>{moment.utc(loadInfo.load_date).format(DISPLAY_DATE_FORMAT2)}</label></td></tr>}
						<tr><td><span>Load Time</span></td><td>:</td><td><label>{moment.utc(loadInfo.start_date).format("hh:mm:ss a")} to {moment.utc(loadInfo.end_date).format("hh:mm:ss a")}</label></td></tr>
						<tr><td><span>Duration</span></td><td>:</td><td><label>{toDisplayTimeString(secondsToTime(loadInfo.load_seconds ? loadInfo.load_seconds : 0, true))}</label></td></tr>
						<tr><td><span>Weight</span></td><td>:</td><td><label>{`${loadInfo.load_capacity ? loadInfo.load_capacity : 0} ${weightShortName}`}</label></td></tr>
						<tr ><td id='goToReplayBox' >
							<span style={
								{
									color: "#1a73e8",
									textDecoration: "underline",
									cursor: "pointer"
								}
							} onClick={() => goToReplayBox(
								{
									source_equipment_group_uuid: loadInfo && checkValidId(loadInfo.source_equipment_group_uuid) ? loadInfo.source_equipment_group_uuid : null,
									crew_uuid: loadInfo && checkValidId(loadInfo.crew_uuid) ? loadInfo.crew_uuid : null,
									target_equipment_group_uuid: loadInfo && checkValidId(loadInfo.target_equipment_group_uuid) ? loadInfo.target_equipment_group_uuid : null,
									load_activity_uuid: loadInfo && loadInfo.load_activity_uuid ? loadInfo.load_activity_uuid : null,
								})} >View on Replay</span>
						</td ></tr>
					</tbody>
				</table >),
					fieldInfoLoadDiv
				);

				const fieldInfoWindow = mapInfoWindow({ content_string: fieldInfoLoadDiv });
				if (filedMarker) {
					google.maps.event.addListener(filedMarker, 'click', () => {
						fieldInfoWindow.open(map, filedMarker)
					});
					filedMarker.setMap(map);
				}
			}
			if (offload) {
				offload.setMap(map);
				let centerLocation = offloadLocation.length !== 0 ? getCenter(offloadLocation) : null;
				const offloadCenterLocation = centerLocation ? { lat: centerLocation.latitude, lng: centerLocation.longitude } : null
				offloadMarker = offloadCenterLocation && drawShape('marker', {
					id: uuid(),
					location: [offloadCenterLocation],
					properties: {
						icon: {
							url: offloadMarkerIcon,
							scaledSize: new google.maps.Size(30, 40),
						},
						visible: true
					}
				});
				const offloadInfoLoadDiv = document.createElement("div");
				offloadInfoLoadDiv.setAttribute("class", 'info-load');

				ReactDOM.render(React.Children.only(
					<table>
						<tbody>
							<tr><td><span>Offload site</span></td><td>:</td><td><label>{offloadShpe.geo_shape_name || "N/A"}</label></td></tr>
							{loadInfo.load_gross_weight !== 0 && <tr><td><span>Load gross Weight</span></td><td>:</td><td><label>{`${loadInfo.load_gross_weight ? loadInfo.load_gross_weight : 0}`} {weightShortName}</label></td></tr>}
							{loadInfo.tare_weight !== 0 && <tr><td><span>Tare Weight</span></td><td>:</td><td><label>{`${loadInfo.tare_weight ? loadInfo.tare_weight : 0}`} {weightShortName}</label></td></tr>}
							{loadInfo.light_weight !== 0 && <tr><td><span>Light Weight</span></td><td>:</td><td><label>{`${loadInfo.light_weight ? loadInfo.light_weight : 0}`} {weightShortName}</label></td></tr>}
							{loadInfo.load_capacity !== 0 && <tr><td><span>Net Weight</span></td><td>:</td><td><label>{`${loadInfo.load_capacity ? loadInfo.load_capacity : 0}`} {weightShortName}</label></td></tr>}
						</tbody>
					</table>),
					offloadInfoLoadDiv
				);
				const offloadInfoWindow = mapInfoWindow({ content_string: offloadInfoLoadDiv });
				if (offloadMarker) {
					google.maps.event.addListener(offloadMarker, 'click', () => {
						offloadInfoWindow.open(map, offloadMarker)
					});
					offloadMarker.setMap(map);
				}
			}
			if (filedMarker && offloadMarker) {
				if (fieldLocation.length !== 0 && offloadLocation.length !== 0) {
					const bounds = new props.google.maps.LatLngBounds();
					[...fieldLocation, ...offloadLocation].forEach(marker => {
						bounds.extend({
							lat: marker.lat,
							lng: marker.lng,
						});
					});
					setMapBounds(bounds);
				}
				setmarker({ field: filedMarker, offload: offloadMarker });
			}
		}

	}, [google])

	const drawShape = (type, data) => {
		if (type === GEO_SHAPE_TYPE.POLYGON) {
			const polygon = shape.createPolygon({
				id: data.id,
				location: data.location,
				properties: data.properties
			});
			return polygon;
		} else if (type === GEO_SHAPE_TYPE.CIRCLE) {
			const circle = shape.createCircle({
				id: data.id,
				location: data.location,
				properties: data.properties
			});
			return circle;
		} else if (type === GEO_SHAPE_TYPE.POLYLINE) {
			const polyline = shape.createPolyline({
				id: data.id,
				location: data.location,
				properties: data.properties
			});
			return polyline;
		} else if (type === GEO_SHAPE_TYPE.POLYLINE) {
			const rectangle = shape.createRectange({
				id: data.id,
				location: data.location,
				properties: data.properties
			});
			return rectangle;
		} else if (type === GEO_SHAPE_TYPE.MARKER) {
			const rectangle = shape.createMarker({
				id: data.id,
				location: data.location,
				properties: data.properties
			});
			return rectangle;
		}
		else {
			return null;
		}
	}

	const mapInfoWindow = (data) => {
		const { content_string } = data;
		const infowindow = new google.maps.InfoWindow({
			content: content_string,
			disableAutoPan: true,
			zIndex: 999
		});
		return infowindow;
	}


	const handleProjectionChanged = () => {
		const { field, offload } = markers;
		if (field && offload && props.google) dashedCurveMarker(field, offload);
	}

	const dashedCurveMarker = (markerP1, markerP2) => {
		var lineLength = google.maps.geometry ? google.maps.geometry.spherical.computeDistanceBetween(markerP1.getPosition(), markerP2.getPosition()) : 1;
		var lineHeading = google.maps.geometry ? google.maps.geometry.spherical.computeHeading(markerP1.getPosition(), markerP2.getPosition()) : 1;
		var markerA = drawShape('marker', {
			id: uuid(),
			location: [google.maps.geometry.spherical.computeOffset(markerP1.getPosition(), lineLength / 6, lineHeading + 60)],
			properties: {
				icon: {
					url: fieldMarkerIcon,
				},
				visible: false
			}
		});

		var markerB = drawShape('marker', {
			id: uuid(),
			location: [google.maps.geometry.spherical.computeOffset(markerP2.getPosition(), lineLength / 6, lineHeading + 120)],
			properties: {
				icon: {
					url: fieldMarkerIcon,
				},
				visible: false
			}
		});

		var markerA1 = drawShape('marker', {
			id: uuid(),
			location: [google.maps.geometry.spherical.computeOffset(markerP1.getPosition(), lineLength / 7.2, lineHeading + 60)],
			properties: {
				icon: {
					url: fieldMarkerIcon,
				},
				visible: false
			}
		});

		var markerB1 = drawShape('marker', {
			id: uuid(),
			location: [google.maps.geometry.spherical.computeOffset(markerP2.getPosition(), lineLength / 7.2, lineHeading + 120)],
			properties: {
				icon: {
					url: fieldMarkerIcon,
				},
				visible: false
			}
		});

		GmapsCubicBezier(markerP1.getPosition(), markerA.getPosition(), markerB.getPosition(), markerP2.getPosition(), 0.01, map, { strokeColor: '#ff8c1a' });
		GmapsCubicBezier(markerP1.getPosition(), markerA1.getPosition(), markerB1.getPosition(), markerP2.getPosition(), 0.01, map, { strokeColor: '#00000021' });
	}

	const GmapsCubicBezier = (latlong1, latlong2, latlong3, latlong4, resolution, map, options) => {
		var lat1 = latlong1.lat();
		var long1 = latlong1.lng();
		var lat2 = latlong2.lat();
		var long2 = latlong2.lng();
		var lat3 = latlong3.lat();
		var long3 = latlong3.lng();
		var lat4 = latlong4.lat();
		var long4 = latlong4.lng();

		var points = [];

		for (let it = 0; it <= 1; it += resolution) {
			points.push(prototype.getBezier({
				x: lat1,
				y: long1
			}, {
				x: lat2,
				y: long2
			}, {
				x: lat3,
				y: long3
			}, {
				x: lat4,
				y: long4
			}, it));
		}
		var path = [];
		for (var i = 0; i < points.length - 1; i++) {
			path.push(new google.maps.LatLng(points[i].x, points[i].y));
			path.push(new google.maps.LatLng(points[i + 1].x, points[i + 1].y, false));
		}

		var polyline = drawShape('polyline', {
			id: uuid(),
			location: path,
			properties: {
				strokeOpacity: 0.0,
				icons: [{
					icon: {
						path: 'M 0,-1 0,1',
						strokeOpacity: 1,
						scale: 4
					},
					offset: '0',
					repeat: '20px'
				}],
				strokeColor: options.strokeColor
			}
		});
		polyline.setMap(map);
		return polyline;
	};

	const prototype = {

		B1: function (t) {
			return t * t * t;
		},
		B2: function (t) {
			return 3 * t * t * (1 - t);
		},
		B3: function (t) {
			return 3 * t * (1 - t) * (1 - t);
		},
		B4: function (t) {
			return (1 - t) * (1 - t) * (1 - t);
		},
		getBezier: function (C1, C2, C3, C4, percent) {
			var pos = {};
			pos.x = C1.x * this.B1(percent) + C2.x * this.B2(percent) + C3.x * this.B3(percent) + C4.x * this.B4(percent);
			pos.y = C1.y * this.B1(percent) + C2.y * this.B2(percent) + C3.y * this.B3(percent) + C4.y * this.B4(percent);
			return pos;
		}
	};

	return (
		<div>
			<Map
				mapType='satellite'
				google={props.google}
				zoom={15}
				option={staticOptions}
				style={mapStyles}
				mapTypeControl={true}
				streetViewControl={false}
				zoomControl={true}
				ref={mapRef}
				initialCenter={loadLocation[0]}
				bounds={mapBounds}
				onProjectionChanged={handleProjectionChanged}
			></Map>
		</div>
	);
};

export default GoogleApiWrapper({
	apiKey: config.common.MAP_API_KEY,
	libraries: ["satellite", "drawing"]
})(memo(LoadMap));